import React from 'react';

import Box from '../Box/Box';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';
import { TButtonsConfig } from './types/TButtons';

const ButtonBase = ({ as = 'button', kind = 'primary', isIconButton, brand, size, ...rest }: TButtonsConfig) => {
  const conditionalProps = filterConditionalKeyValues({
    modifiers: [kind, isIconButton ? 'icon-button' : '', brand ? brand : '', size],
  });

  return <Box {...rest} name="Button" as={as} {...conditionalProps} />;
};

export default React.memo(ButtonBase);
